module.exports = __webpack_public_path__ + "static/img/img.3847c1c4.jpg";